module.exports = __webpack_public_path__ + "img/ic_oui_white.32df512e.svg";